import Vue from "vue";
import Router from "vue-router";
import * as GLOBALS from '@/globals';

/*
Lazy Load Routes - https://router.vuejs.org/guide/advanced/lazy-loading.html#lazy-loading-routes
*/
// General Pages
const PageNotFound = () => import('./views/NotFound.vue');

// Templates
const Home = () => import('./views/Home.vue');
const Recipients = () => import('./views/Recipients.vue');
const Topics = () => import('./views/Topics.vue');
const Topic = () => import('./views/Topic.vue');
const Section = () => import('./views/ContentSection.vue');
const ShareContent = () => import('./views/ShareContent.vue');
const Finished = () => import('./views/Finished.vue');
const Shared = () => import('./views/Shared.vue');
const General = () => import('./views/General.vue');

Vue.use(Router);

const router = new Router({
	mode: 'history',
	scrollBehavior() {
		// Go to top of page when changing routes
		return {x: 0, y: 0};
	},
	routes: [{
			path: "/",
			name: GLOBALS.ROUTE_HOME,
			component: Home
		},
		{
			path: "/recipients",
			name: GLOBALS.ROUTE_RECIPIENTS,
			component: Recipients
		},
		{
			path: "/topics",
			name: GLOBALS.ROUTE_TOPICS,
			component: Topics
		},
		{
			path: "/topic/:slug/:pageNumber?",
			name: GLOBALS.ROUTE_TOPIC,
			component: Topic
		},
		{
			path: "/content-section/:slug",
			name: GLOBALS.ROUTE_CONTENT_SECTION,
			component: Section
		},
		{
			path: "/share-content",
			name: GLOBALS.ROUTE_SHARE_CONTENT,
			component: ShareContent
		},
		{
			path: "/finished",
			name: GLOBALS.ROUTE_FINISHED,
			component: Finished
		},
		{
			path: "/shared/:uid",
			name: GLOBALS.ROUTE_SHARED,
			component: Shared
		},
		{
			path: "/:slug",
			name: GLOBALS.ROUTE_GENERAL,
			component: General
		},
		{
			path: '/not-found',
			name: GLOBALS.ROUTE_NOT_FOUND,
			component: PageNotFound
		},
		{
			path: '*',
			component: PageNotFound
		}
	]
});

export default router;